<template>
  <!-- Table Container Card -->
  <validation-observer ref="accountOfficerRules">
    <b-form>
      <b-row class="match-height">
        <!--  Linked User -->
        <b-col md="6">
          <SelectField
            id="select-user"
            v-model="accountOfficerFormData.linkedUser"
            :label="$t('Select User')"
            :options="userOptions"
            :placeholder="$t('Select')"
            :reduce="option => option.value"
            item="label"
            rules="required"
            :error-name="$t('Select User')"
            :set-selected="setUserDetails"
            :loading="isLoading"
            :readonly="isReadonly"
          />
        </b-col>
        <!--  User Options -->

        <!-- First names -->
        <b-col md="6">
          <InputField
            id="first-name"
            v-model="accountOfficerFormData.otherNames"
            :label="$t('First Names')"
            :placeholder="$t('Enter First names')"
            type="text"
            :error-name="$t('First Names')"
            rules="required"
            for="first-name"
            readonly
            onpaste="return false;"
            :is-allow-special-characters="false"
          />
        </b-col>
        <!-- First names -->

        <!-- Last Name -->
        <b-col md="6">
          <InputField
            id="last-name"
            v-model="accountOfficerFormData.lastName"
            :label="$t('Last Name')"
            :placeholder="$t('Enter last name')"
            type="text"
            :error-name="$t('Last Name')"
            rules="required"
            readonly
            onpaste="return false;"
            :is-allow-special-characters="false"
          />
        </b-col>
        <!-- Last Name -->

        <!-- Branch -->
        <b-col md="6">
          <SelectField
            id="branch"
            v-model="accountOfficerFormData.branchCode"
            :label="$t('Branch')"
            :options="branchOptions"
            :reduce="option => option.value"
            :error-name="$t('Branch')"
            rules="required"
            item="label"
            readonly
            :placeholder="$t('Select Branch')"
          />
        </b-col>
        <!--Branch -->

        <!--Staff ID -->
        <b-col md="6">
          <InputField
            id="staff-id"
            v-model="accountOfficerFormData.staffID"
            :label="$t('Staff ID')"
            :placeholder="$t('Enter staff ID')"
            type="text"
            :error-name="$t('Staff ID')"
            rules="required"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Staff ID -->

        <!-- Phone number -->
        <b-col md="6">
          <InputField
            id="phone-number"
            v-model="accountOfficerFormData.phoneNumber"
            :label="$t('Phone Number')"
            :placeholder="$t('Enter phone number')"
            type="number"
            :error-name="$t('Phone Number')"
            rules="required|integer|min:7|max:11"
            onpaste="return false;"
            :is-allow-special-characters="false"
            readonly
          />
        </b-col>
        <!-- Phone number -->

        <!-- Access Level -->
        <b-col md="6">
          <SelectField
            id="access-level"
            v-model="accountOfficerFormData.accessLevel"
            :label="$t('Access Level')"
            :placeholder="$t('Select')"
            :options="accessLevelOptions"
            :reduce="option => option.value"
            :error-name="$t('Access Level')"
            rules="required"
            item="label"
            :readonly="isReadonly"
          />
        </b-col>
        <!--Access Level -->

        <!--Gender -->
        <b-col md="6">
          <SelectField
            id="gender"
            v-model="accountOfficerFormData.gender"
            :label="$t('Gender')"
            :placeholder="$t('Select')"
            :options="genderOptions"
            :reduce="option => option.value"
            :error-name="$t('Gender')"
            rules="required"
            item="label"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Gender -->

      </b-row>
      <b-row class="match-height">
        <b-col md="12">
          <TextAreaField
            id="address"
            v-model="accountOfficerFormData.address"
            :label="$t('Address')"
            :placeholder="$t('Enter address')"
            :error-name="$t('Address')"
            rules="required"
            for="address"
            rows="4"
            readonly
          />
        </b-col>
      </b-row>
      <b-row>
        <!-- Supervisor Name -->
        <b-col md="6">
          <SelectField
            id="select-user"
            v-model="accountOfficerFormData.supervisor"
            :label="$t('Supervisor Name')"
            :options="userOptions"
            :placeholder="$t('Select')"
            :reduce="option => option.value"
            item="label"
            rules="required"
            :error-name="$t('Supervisor Name')"
            :loading="isLoading"
            :readonly="isReadonly"
            :set-selected="setSupervisorDetails"
          />
        </b-col>
        <!-- Supervisor Name -->
        <b-col md="6">
          <InputField
            id="supervisor-email"
            v-model="supervisorEmail"
            :label="$t('Supervisor Email')"
            :placeholder="$t('Enter Supervisor Email')"
            type="text"
            :error-name="$t('Supervisor Email')"
            rules="required"
            readonly
          />
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow, BCol, BForm,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { ValidationObserver } from 'vee-validate'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import { gender, accessLevel } from '../../../../helpers/data'
import { accountPermissions } from '../../../../helpers/permissions'
import TextAreaField from '../../../forms/TextAreaField.vue'

export default {
  name: 'AccountOfficerForm',
  components: {
    BRow,
    BCol,
    BForm,
    SelectField,
    InputField,
    TextAreaField,
    ValidationObserver,
  },
  mixins: [tableMixins, sweetAlert, permissionMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    initialFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isReadonly: false,
      isEditable: false,
      showSpinner: false,
      isLoading: false,
      buttonLabel: 'Save',
      accountOfficerFormData: {
        linkedUser: '',
        lastName: '',
        otherNames: '',
        staffID: '',
        phoneNumber: '',
        accessLevel: null,
        gender: null,
        address: '',
        branchCode: '',
        supervisor: '',
        id: '',
      },
      filter: {
        name: '',
        staffID: '',
        gender: '',
        phoneNumber: '',
        branchCode: '',
        status: '',
        sortColumn: '',
      },
      supervisorEmail: '',
      accountOfficerList: [],
      userOptions: [],
      required,
      minPhoneVal,
      maxPhoneVal,
    }
  },
  computed: {
    ...mapGetters({
      branchOptions: 'operations/branchOptions',
    }),
    accessLevelOptions() {
      return accessLevel.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
    genderOptions() {
      return gender.map(item => ({ label: this.$t(item.label), value: item.value }))
    },
  },
  watch: {
    isEdit: {
      immediate: true,
      handler(val) {
        this.isReadonly = val
      },
    },
    initialFormData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (Object.keys(newValue).length) {
          this.accountOfficerFormData = {
            ...this.accountOfficerFormData,
            ...newValue,
          }
          // If supervisor email is included
          if (newValue.supervisor) {
            this.supervisorEmail = newValue.supervisorEmail || ''
          }
        }
      },
    },
    accountOfficerFormData: {
      handler() {
        this.emitFormUpdate()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchAccountOfficer()
    this.fetchUsers()
    this.getAllBranches({ permission: accountPermissions.VIEW_ACCOUNT_OFFICER })
  },
  methods: {
    ...mapActions({
      getAllBranches: 'operations/getAllBranches',
      getAccountOfficer: 'account/getAccountOfficerList',
      updateAccountOfficer: 'account/updateAccountOfficerAction',
      createAccountOfficer: 'account/createAccountOfficerAction',
      updateAccountOfficerStatus: 'account/updateStatus',
      getUsers: 'admin/getUserList',
      getUserByEmail: 'admin/getUserByEmail',
    }),
    emitFormUpdate() {
      this.$emit('update', {
        formData: this.accountOfficerFormData,
      })
    },
    async fetchUsers() {
      try {
        const response = await this.getUsers({
          status: 'Active',
          permission: accountPermissions.VIEW_ACCOUNT_OFFICER,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.userOptions = data.data.map(items => ({
            label: `${items.firstname} ${items.lastname}`,
            value: items.email,
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchAccountOfficer() {
      try {
        const response = await this.getAccountOfficer({
          search: { ...this.filter, status: 'Active' },
          page: this.currentPage,
          limit: this.perPage,
          permission: accountPermissions.VIEW_ACCOUNT_OFFICER,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.accountOfficerList = data.data
          this.totalCount = data.recordCount
        } else {
          this.accountOfficerList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async setUserDetails(email) {
      try {
        this.isLoading = true
        const response = await this.getUserByEmail({
          email,
          permission: accountPermissions.VIEW_ACCOUNT_OFFICER,
        })
        const { status, data } = await response
        if (status === 200) {
          const dataItem = data.data[0]
          this.accountOfficerFormData = {
            ...this.accountOfficerFormData,
            linkedUser: dataItem.email,
            lastName: dataItem.lastname,
            otherNames: dataItem.firstname,
            phoneNumber: dataItem.phoneNumber,
            accessLevel: dataItem.accessLevel,
            address: dataItem.address,
            branchCode: dataItem.branchCode,
          }
          this.emitFormUpdate()
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoading = false
      }
    },

    async setSupervisorDetails(email) {
      if (email) {
        this.supervisorEmail = email
        this.emitFormUpdate()
      }
    },
    // handleSubmit(bvModalEvt) {
    //   bvModalEvt.preventDefault()
    //   this.$refs.accountOfficerForm.validate().then(success => {
    //     if (success) {
    //       const actionText = this.buttonLabel === this.$t('Save')
    //         ? this.$t('Are you sure you want to Save this Account Officer?')
    //         : this.$t('Are you sure you want to Update this Account Officer?')
    //       this.confirm(this.accountOfficerAction, { text: actionText })
    //     }
    //   })
    // },
    async accountOfficerAction() {
      try {
        this.isLoading = true
        delete this.accountOfficerFormData.name
        const { lastName, otherNames } = this.accountOfficerFormData
        const formData = {
          ...this.accountOfficerFormData,
          staffName: `${lastName} ${otherNames}`,
        }
        const response = this.buttonLabel === 'Save'
          ? await this.createAccountOfficer(formData)
          : await this.updateAccountOfficer({
            ...this.accountOfficerFormData,
            staffName: `${lastName} ${otherNames}`,
            branchCode: this.branchOptions.find(item => (item.label === this.accountOfficerFormData.branchCode || item.value === this.accountOfficerFormData.branchCode)).value,
          })
        const { status } = response
        if (status === 200) {
          this.fetchAccountOfficer()
          this.hideModal('modal-lg')
          const successMessage = this.buttonLabel === this.$t('Save')
            ? this.$t('Your request to Save Account Officer was successful')
            : this.$t('Your request to Update Account Officer was successful')
          this.alertSuccess({ text: successMessage })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    resetModal() {
      try {
        this.accountOfficerFormData = {
          linkedUser: '',
          lastName: '',
          otherNames: '',
          staffID: '',
          phoneNumber: '',
          accessLevel: null,
          gender: null,
          address: '',
          branchCode: '',
          supervisor: '',
          id: '',
        }
        this.supervisorEmail = ''
        this.isLoading = false
        this.isEditable = this.isEdit
        this.buttonLabel = this.isEdit ? this.$t('Update') : this.$t('Save')
        this.modalTitle = this.isEdit ? this.$t('Edit Account Officer') : this.$t('Create Account Officer')
        if (this.isEdit) {
          this.modalTitle = this.$t('View Account Officer')
        }
      } catch (error) {
        console.log({ error })
      }
    },
  },
}
</script>
